// extracted by mini-css-extract-plugin
export default {"container":"nav-header_container__aDb61","loginBtn":"nav-header_loginBtn__okJDB","tag":"nav-header_tag__xREdq"};